var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 115,
    viewBox: "0 0 117 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_512_1933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.4143 29.4007L66.6581 21.0928C66.2855 19.9144 65.4301 18.9185 64.2435 18.3835C62.5488 17.6172 61.868 17.2145 61.6068 17.0058C61.5527 16.6758 61.5367 15.8785 61.6968 14.0323C61.8852 11.8636 60.5002 9.88686 58.3914 9.33518C56.2826 8.78349 54.1071 9.82869 53.2092 11.8118C52.443 13.5065 52.0469 14.189 51.8316 14.4485C51.5016 14.5025 50.7043 14.5185 48.858 14.3584C47.5614 14.2438 46.3279 14.6932 45.426 15.5382L37.9895 13.5927L16.1673 31.6499L30.8446 65.4255C30.7894 65.5023 30.7525 65.5629 30.7142 65.602C30.3776 65.6543 29.5869 65.672 27.7424 65.5053C25.5737 65.317 23.597 66.702 23.0453 68.8108C22.4936 70.9195 23.5388 73.0951 25.5219 73.9929C27.2166 74.7591 27.8973 75.1619 28.1586 75.3706C28.2126 75.7006 28.2287 76.4979 28.0685 78.3441C27.8802 80.5128 29.2652 82.4895 31.374 83.0412C33.4827 83.5929 35.6583 82.5477 36.5561 80.5646C36.7215 80.2008 36.8683 79.8812 37.0047 79.601L46.9839 102.574L108.591 55.8293L98.4011 29.3972L98.4143 29.4007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5968 33.2066L96.1819 32.1365L96.1753 32.1348L96.1177 31.9793L38.7345 16.9671L37.596 17.9116L19.9057 32.5435L20.4213 33.7383L20.4262 33.7466L47.2278 95.4149L47.2344 95.4166L47.5316 96.105L48.0202 97.2155L48.0538 97.3015L48.2564 97.7616L48.5619 97.5327L48.8757 97.299L48.8823 97.3007L49.3225 96.9596L49.5351 96.7906L103.867 55.5618L103.873 55.5635L104.91 54.7678L96.6051 33.2018L96.5968 33.2066ZM103.2 53.2537L78.7754 46.8638L95.7365 33.8659L103.2 53.2537ZM49.0571 41.2298L75.5906 48.1714L49.2906 93.0838L49.0571 41.2298ZM50.1002 39.3619L66.7595 27.0081L75.2345 45.9374L50.1002 39.3619ZM94.0893 32.5156L77.2695 45.4029L68.5018 25.8215L94.0893 32.5156ZM65.828 25.122L48.4697 38.0019L40.0565 18.3798L65.8346 25.1237L65.828 25.122ZM38.0233 18.9077L46.382 38.3892L22.1345 32.0457L38.0233 18.9077ZM21.7023 34.0734L46.9877 40.6885L47.2171 92.773L21.7023 34.0734ZM50.8963 94.4585L77.6731 48.7162L102.584 55.2333L50.8963 94.4585Z",
    fill: "url(#paint0_linear_512_1933)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8874 31.1067L38.4859 15.828L18.6515 32.2434L47.8327 99.3843L106.155 55.1356L96.8939 31.1084L96.8874 31.1067ZM103.653 54.4248L102.583 55.2399L50.8954 94.4652L49.3028 95.6699L48.6783 96.1522L48.1768 95.0103L47.2194 92.7945L47.2128 92.7928L21.6998 34.0867L21.1664 32.8522L22.1337 32.0524L38.0224 18.9144L38.9914 18.108L95.3432 32.8505L95.7422 33.8743L103.206 53.2621L103.658 54.4331L103.653 54.4248Z",
    fill: "#1D074F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2155 92.7796L21.709 34.0752L46.9878 40.6885L47.2155 92.7796Z",
    fill: "url(#paint1_linear_512_1933)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5922 48.1715L49.2921 93.084L49.0586 41.23L75.5922 48.1715Z",
    fill: "url(#paint2_linear_512_1933)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.585 55.2332L50.8952 94.465L77.6804 48.7179L102.585 55.2332Z",
    fill: "url(#paint3_linear_512_1933)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.2 53.2538L78.7756 46.8639L95.7349 33.8726L103.2 53.2538Z",
    fill: "url(#paint4_linear_512_1933)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0961 32.5176L77.2745 45.4115L68.502 25.8218L94.0961 32.5176Z",
    fill: "url(#paint5_linear_512_1933)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2414 45.9393L50.1072 39.3638L66.7664 27.0099L75.2414 45.9393Z",
    fill: "url(#paint6_linear_512_1933)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8282 25.1221L48.4698 38.002L40.0566 18.3799L65.8282 25.1221Z",
    fill: "url(#paint7_linear_512_1933)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3819 38.3892L22.1344 32.0457L38.0232 18.9077L46.3819 38.3892Z",
    fill: "url(#paint8_linear_512_1933)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.391 53.5649L20.9473 31.7349L20.4231 33.7385L103.867 55.5686L104.391 53.5649Z",
    fill: "#1D074F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.124 47.3178L77.0498 47.8019L76.2388 48.1653L75.9638 47.5529L75.2419 45.9392L66.7668 27.0098L50.1076 39.3637L49.0598 40.1494L48.7842 40.344L48.2908 39.6815L47.95 39.2133L47.5587 38.6968L47.549 38.6803L48.4705 38.0019L65.8288 25.122L66.8981 24.3348L67.6038 23.8106L67.9623 24.6133L68.5026 25.8215L77.2751 45.4112L77.8105 46.6111L77.9454 46.9272L78.124 47.3178Z",
    fill: "#1D074F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0498 39.3542L48.2902 39.6819L47.1452 40.1684L46.9829 39.7961L46.9846 39.7895L46.3822 38.3896L38.0235 18.9081L37.5963 17.9119L37.4052 17.4619L39.3098 16.6476L39.5362 17.1771L40.0567 18.3802L48.4699 38.0022L48.9246 39.0547L48.9887 39.2119L49.0498 39.3542Z",
    fill: "#1D074F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8584 33.0151L96.5977 33.2066L95.7356 33.8724L78.7763 46.8637L78.3727 47.1722L77.24 48.0411L77.0499 47.8018L76.3501 46.8817L75.9781 46.3984L76.2405 46.2003L77.2752 45.4111L94.0968 32.5172L95.1398 31.7232L95.5965 31.3724L96.0464 31.9603L96.1779 32.1281L96.1828 32.1364L96.8584 33.0151Z",
    fill: "#1D074F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3127 97.2938L49.2352 97.2946L48.8761 97.2989L48.8678 97.3038L48.1597 97.301L48.0542 97.3015L47.2389 97.3058L47.2416 96.759L47.2383 96.6107L47.2348 95.4166L47.23 95.4083L47.2206 92.7878L47.2158 92.7795L46.9881 40.6884L46.9879 39.804L46.9848 39.7891L46.9795 39.2192L47.9496 39.2133L48.9889 39.2114L49.0532 39.2072L49.0499 39.3537L49.0594 40.1494L49.0575 41.2298L49.291 93.0838L49.2893 93.0904L49.3041 95.6631L49.3163 96.9579L49.3107 97.167L49.3127 97.2938Z",
    fill: "#1D074F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5306 47.2632L77.6797 48.7182L50.8946 94.4653L49.5269 96.7957L49.3104 97.1672L49.2349 97.2949L48.9628 97.7712L48.5554 97.5312L48.1593 97.3013L48.0202 97.2158L47.2412 96.7593L47.1741 96.7207L47.2379 96.611L47.5316 96.1053L48.1777 95.0039L49.2889 93.0906L49.2906 93.0841L75.5907 48.1716L75.963 47.5531L76.3492 46.882L76.6864 46.3175L76.7402 46.2193L77.0937 46.4241L77.9446 46.9274L78.3719 47.1726L78.5306 47.2632Z",
    fill: "#1D074F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2515 79.7399C31.7654 79.6127 31.4378 79.148 31.4844 78.6478C31.9374 73.5091 31.6415 73.0035 26.9393 70.882C26.4804 70.6777 26.2356 70.1644 26.3628 69.6783C26.49 69.1922 26.9547 68.8645 27.4549 68.9112C32.5936 69.3641 33.0992 69.0682 35.2207 64.3661C35.425 63.9071 35.9383 63.6624 36.4244 63.7895C36.9105 63.9167 37.2382 64.3815 37.1915 64.8816C36.7386 70.0203 37.0345 70.5259 41.7366 72.6475C42.1956 72.8518 42.4403 73.365 42.3132 73.8511C42.186 74.3373 41.7212 74.6649 41.221 74.6183C36.0823 74.1653 35.5768 74.4612 33.4552 79.1634C33.2509 79.6223 32.7377 79.8671 32.2515 79.7399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1631 64.7881C35.6724 70.3661 36.2109 71.2861 41.3146 73.5899C35.7365 73.0992 34.8166 73.6377 32.5127 78.7414C33.0034 73.1633 32.465 72.2433 27.3613 69.9395C32.9393 70.4302 33.8593 69.8918 36.1631 64.7881ZM36.6873 62.7844C35.7085 62.5284 34.6903 63.013 34.2734 63.9357C33.3535 65.9762 32.6776 67.2453 31.9417 67.6705C31.2123 68.0973 29.7731 68.0717 27.5436 67.8745C26.5349 67.7861 25.6137 68.4365 25.3577 69.4153C25.1016 70.3942 25.5862 71.4124 26.5089 71.8292C28.5495 72.7491 29.8185 73.4251 30.2437 74.161C30.6705 74.8903 30.645 76.3295 30.4477 78.5591C30.3593 79.5677 31.0097 80.4889 31.9886 80.745C32.9674 81.0011 33.9856 80.5164 34.4025 79.5937C35.3223 77.5532 35.9983 76.2841 36.7342 75.859C37.4635 75.4321 38.9027 75.4577 41.1323 75.6549C42.141 75.7433 43.0622 75.0929 43.3182 74.1141C43.5743 73.1353 43.0897 72.1171 42.1669 71.7002C40.1264 70.7803 38.8573 70.1044 38.4322 69.3685C38.0053 68.6391 38.0309 67.1999 38.2282 64.9704C38.3166 63.9617 37.6661 63.0405 36.6873 62.7844Z",
    fill: "#1D074F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3551 28.5895C52.8689 28.4623 52.5413 27.9976 52.5879 27.4974C53.0409 22.3587 52.745 21.8531 48.0428 19.7316C47.5839 19.5273 47.3391 19.014 47.4663 18.5279C47.5935 18.0418 48.0582 17.7141 48.5584 17.7608C53.6971 18.2137 54.2027 17.9178 56.3242 13.2157C56.5285 12.7567 57.0418 12.512 57.5279 12.6392C58.014 12.7663 58.3417 13.2311 58.295 13.7313C57.8421 18.87 58.138 19.3755 62.8401 21.4971C63.2991 21.7014 63.5438 22.2146 63.4167 22.7008C63.2895 23.1869 62.8247 23.5145 62.3246 23.4679C57.1859 23.0149 56.6803 23.3108 54.5587 28.013C54.3544 28.4719 53.8412 28.7167 53.3551 28.5895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2666 13.6377C56.776 19.2157 57.3144 20.1357 62.4181 22.4395C56.84 21.9488 55.9201 22.4873 53.6163 27.591C54.1069 22.0129 53.5685 21.093 48.4648 18.7891C54.0429 19.2798 54.9628 18.7414 57.2666 13.6377ZM57.7908 11.634C56.812 11.378 55.7938 11.8626 55.3769 12.7853C54.4571 14.8259 53.7811 16.0949 53.0452 16.5201C52.3093 16.9452 50.8766 16.9214 48.6471 16.7241C47.6384 16.6357 46.7173 17.2861 46.4612 18.265C46.2051 19.2438 46.6897 20.262 47.6125 20.6789C49.653 21.5987 50.922 22.2747 51.3472 23.0106C51.7741 23.7399 51.7485 25.1791 51.5513 27.4087C51.4628 28.4174 52.1132 29.3385 53.0921 29.5946C54.0709 29.8507 55.0891 29.366 55.506 28.4433C56.4259 26.4028 57.1018 25.1337 57.8377 24.7086C58.567 24.2817 60.0063 24.3073 62.2358 24.5045C63.2445 24.5929 64.1657 23.9425 64.4217 22.9637C64.6778 21.9849 64.1932 20.9667 63.2704 20.5498C61.2299 19.6299 59.9609 18.954 59.5357 18.2181C59.1089 17.4887 59.1344 16.0495 59.3317 13.82C59.4201 12.8113 58.7697 11.8901 57.7908 11.634Z",
    fill: "#1D074F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1428 34.6245L91.1479 37.242L97.0232 52.3186L66.9149 78.2241L87.0115 49.6994L81.1428 34.6245Z",
    fill: "white",
    stroke: "#1D074F",
    strokeWidth: 3.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_512_1933",
    x: 15.168,
    y: 6.18848,
    width: 100.424,
    height: 101.385,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0.6 0 0 0 0 0.6 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_512_1933"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_512_1933",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_512_1933",
    x1: 67.4229,
    y1: 24.4723,
    x2: 48.2498,
    y2: 97.7599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#0FD2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F8EE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_512_1933",
    x1: 37.1055,
    y1: 38.1382,
    x2: 31.3812,
    y2: 92.9117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A94EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9643E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8337C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#7730B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732EB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_512_1933",
    x1: 62.3287,
    y1: 44.7016,
    x2: 49.6469,
    y2: 93.1768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#0FD2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F8EE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_512_1933",
    x1: 88.8985,
    y1: 32.3716,
    x2: 72.2007,
    y2: 90.7247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FDFE0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FDCC0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_512_1933",
    x1: 91.2338,
    y1: 37.6364,
    x2: 90.6796,
    y2: 65.8059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A94EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9643E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8337C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#7730B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732EB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_512_1933",
    x1: 81.299,
    y1: 29.1697,
    x2: 77.0643,
    y2: 45.3565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FDFE0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FDCC0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_512_1933",
    x1: 66.7664,
    y1: 27.0099,
    x2: 62.6743,
    y2: 42.6515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FF63BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF0FE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_512_1933",
    x1: 52.9457,
    y1: 21.7518,
    x2: 48.68,
    y2: 38.0569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#0FD2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F8EE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_512_1933",
    x1: 38.4961,
    y1: 19.0315,
    x2: 34.2614,
    y2: 35.2183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FDFE0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FDCC0C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGroup1);
export default __webpack_public_path__ + "static/media/ic_group-1.3828fba7cca540c709e9bc5360a49c05.svg";
export { ForwardRef as ReactComponent };